import { Fragment } from 'react'

import { config } from '../config'
import { Title } from '../styles'

import { Wrapper, Subtitle, Text, HexagonGray, HexagonOrange } from './styles'

const {
  development: { title, processes, images },
} = config

const { hexagonGray, hexagonOrange } = images

export function Development() {
  return (
    <Wrapper>
      <Title as="h2">{title}</Title>
      {processes.map(({ id, title, subtitle }) => (
        <Fragment key={id}>
          <Subtitle as="h3">{title}</Subtitle>
          <Text>{subtitle}</Text>
        </Fragment>
      ))}
      <HexagonOrange {...hexagonOrange} />
      <HexagonGray {...hexagonGray} />
    </Wrapper>
  )
}
